import { CSSProperties, useState, useMemo } from 'react'
import Style from './home.module.scss'
import { Layout, Button } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import Custompreviewimg from '../../components/PreviewUser'
import companyicon from '../../assets/img/icon_conpany.png'
import xhOrderIcon from '../../assets/img/xhOrderIcon.png'
import myMaterialIcon from '../../assets/img/myMaterialIcon.png'
import myQuotationIcon from '../../assets/img/myQuotationIcon.png'
import wait_acceptance from '../../assets/img/wait_acceptance.png'
import clientOrderIcon from '../../assets/img/clientOrderIcon.png'
import wait_invoice_statement from '../../assets/img/wait_invoice_statement.png'
import useHooks from './hooks'
import { GetLocalStorage } from '../../tools/util'
import { Link } from 'react-router-dom'
import MessageBox from '../../modules/home/messagebox'
import TodoList from '../../modules/home/todolist'
import DashboardCard from '../../modules/home/dashboardcard'
import {
  DashboardCardSkeleton,
  CompanyInfoSkeleton,
  MessageBoxSkeleton,
} from '../../modules/home/skeletons'
import withoput_bussiness_license from '../../assets/img/withoput_bussiness_license.png'
import { StatusSearchDataEnum } from '../XhQuotation'
// 主页
const Homepage = () => {
  const {
    conpanyInfo,
    matterInfo,
    onRefresh,
    onJump,
    spinning,
    paymentCount,
    newestInvoice,
    jumpToNoticeDetail,
    permissionList,
    supplierCount,
    inquiryCount,
    workbenchPermissionList,
    workbenchMatter,
    workbenchCustomerOrder,
    workbenchInquiry,
    workbenchXhOrder,
    workbenchMatterLoading,
    workbenchCustomerOrderLoading,
    workbenchInquiryLoading,
    workbenchXhOrderLoading,
  } = useHooks()
  const { Content } = Layout
  const [previewimg, setPreviewimg] = useState<{
    data: string[]
    currentIndex?: number
  }>({ data: [] })
  const onClickPreview = () => {
    setPreviewimg({
      data: [conpanyInfo.licenseUrl],
      currentIndex: 0,
    })
  }
  const setType = (type: string) => {
    switch (type) {
      case '1':
        return '存续'
      case '2':
        return '在业'
      case '3':
        return '吊销'
      case '4':
        return '注销'
      case '5':
        return '迁入'
      case '6':
        return '迁出'
      case '7':
        return '停业'
      case '8':
        return '清算'
      default:
        break
    }
  }

  // 构建看板卡片数据
  const dashboardCards = useMemo(() => {
    const cards = []

    // 根据看板权限列表显示对应的卡片
    // 1. 电供客户订单
    if (workbenchPermissionList.includes('电供客户订单')) {
      cards.push({
        title: '电供客户订单',
        mainNumber: workbenchCustomerOrder?.totalCount || 0,
        icon: clientOrderIcon,
        loading: workbenchCustomerOrderLoading,
        link: '/srm/orderassurance?tab=total',
        items: [
          {
            label: '销项待开',
            value: workbenchCustomerOrder?.beInvoicedCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=all&orderState=已完成&accountOpenInvoiceStatus=未开票&positiveActualAmountOnly=true',
          },
          {
            label: '待结算',
            value: workbenchCustomerOrder?.beCollectedCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=all&paymentStatus=待申请',
          },
          {
            label: '待发货',
            value: workbenchCustomerOrder?.beShippedCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=waitship',
          },
          {
            label: '待验收',
            value: workbenchCustomerOrder?.beAcceptedCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=waitacceptance',
          },
          {
            label: '发货超期',
            value: workbenchCustomerOrder?.shipmentOverdueCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=overdue&overdueType=1',
            color: '#FF0000',
          },
          {
            label: '妥投超期',
            value: workbenchCustomerOrder?.properOverdueCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=overdue&overdueType=2',
            color: '#FF0000',
          },
        ],
      })
    }

    // 2. 咸亨订单
    if (workbenchPermissionList.includes('咸亨订单')) {
      cards.push({
        title: '咸亨订单',
        mainNumber: workbenchXhOrder?.totalCount || 0,
        icon: xhOrderIcon,
        loading: workbenchXhOrderLoading,
        link: '/srm/orderassurance?page=SUPPLIER&tab=all',
        items: [
          {
            label: '待接单',
            value: workbenchXhOrder?.bePendingCount || 0,
            // 待接单：跳转到待发货tab，并且筛选待确认标签
            link: '/srm/orderassurance?page=SUPPLIER&tab=waitship&confirmState=true',
          },
          {
            label: '待发货',
            value: workbenchXhOrder?.beShippedCount || 0,
            link: '/srm/orderassurance?page=SUPPLIER&tab=waitship',
          },
        ],
      })
    }

    // 3. 我的询价单
    if (workbenchPermissionList.includes('我的询价单')) {
      cards.push({
        title: '我的询价单',
        mainNumber: workbenchInquiry?.totalCount || 0,
        icon: myQuotationIcon,
        loading: workbenchInquiryLoading,
        link: `/srm/xhQuotation?tab=${StatusSearchDataEnum.ALL}`,
        items: [
          {
            label: '待接单',
            value: workbenchInquiry?.bePendingCount || 0,
            link: `/srm/xhQuotation?tab=${StatusSearchDataEnum.PENDING}&status=WAITING_ORDER`, // 未完结tab，状态=待接单
          },
          {
            label: '待报价',
            value: workbenchInquiry?.beQuotedCount || 0,
            link: `/srm/xhQuotation?tab=${StatusSearchDataEnum.PENDING}&status=WAITING_QUOTE,WAITING_REQUOTE`, // 未完结tab，状态=待报价or待重新报价
          },
        ],
      })
    }

    // 4. 我的物料
    if (workbenchPermissionList.includes('我的物料')) {
      cards.push({
        title: '我的物料',
        mainNumber: workbenchMatter?.totalCount || 0,
        icon: myMaterialIcon,
        loading: workbenchMatterLoading,
        link: '/srm/goods',
        items: [
          {
            label: '审核中',
            value: workbenchMatter?.examineProductCount || 0,
            link: '/srm/mylaunch?type=LAUNCHGOODS',
          },
          {
            label: '驳回品牌',
            value: workbenchMatter?.rejectedBrandCount || 0,
            link: '/srm/mylaunch?type=LAUNCHBRAND&status=reject',
          },
          {
            label: '驳回物料',
            value: workbenchMatter?.rejectedProductCount || 0,
            link: '/srm/mylaunch?type=LAUNCHGOODS&status=reject',
          },
        ],
      })
    }

    return cards
  }, [
    workbenchPermissionList,
    workbenchMatter,
    workbenchCustomerOrder,
    workbenchInquiry,
    workbenchXhOrder,
    workbenchMatterLoading,
    workbenchCustomerOrderLoading,
    workbenchInquiryLoading,
    workbenchXhOrderLoading,
  ])

  return (
    <Layout style={{ height: '100%' }}>
      <Content className={Style.content}>
        {/* 数据看板区域 */}
        <div className={Style.dashboardSection}>
          {newestInvoice && (
            <div className={Style['xh-notice']}>
              <div className={Style['newest-notice']}>
                <span
                  style={{
                    color: '#435AFF',
                    marginRight: '8px',
                  }}
                >
                  <FileTextOutlined className={Style.mr8} />
                  公告
                  <span className={Style.ml8}>|</span>
                </span>
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={jumpToNoticeDetail}
                >
                  {newestInvoice?.title || ''}
                </span>
              </div>
              <div
                className="primaryBtn"
                style={{ cursor: 'pointer', fontSize: '14px' }}
              >
                <Link to="/srm/xhNotice">
                  <span>{'全部 >>'}</span>
                </Link>
              </div>
            </div>
          )}
          <div className={Style.dashboardGrid}>
            {dashboardCards.map((card, index) => {
              const { loading, ...cardProps } = card
              return loading ? (
                <DashboardCardSkeleton key={index} />
              ) : (
                <DashboardCard key={index} {...cardProps} />
              )
            })}
          </div>
        </div>

        {/* 底部左右布局 */}
        <div className={Style.bottomSection}>
          {/* 左侧：待办事项清单 */}
          <div className={Style.leftSection}>
            <TodoList />
          </div>

          {/* 右侧：企业信息和消息通知 */}
          <div className={Style.rightSection}>
            {/* 企业信息 */}
            {spinning ? (
              <CompanyInfoSkeleton />
            ) : (
              <div className={Style.mainbox}>
                <div className={Style.maintitle}>
                  <span className={Style.maintitletext}>企业信息</span>
                  <div className={Style.mainheadbtn}>
                    <span
                      className="primaryBtn"
                      style={{
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '400',
                      }}
                      onClick={() => onJump('xhemployee')}
                    >
                      更多
                    </span>
                  </div>
                </div>
                <div className={Style.mainconpanypic}>
                  {conpanyInfo.licenseUrl ? (
                    <img
                      style={{
                        width: '240px',
                        height: '160px',
                        marginLeft: '20px',
                      }}
                      onClick={onClickPreview}
                      src={conpanyInfo.licenseUrl}
                      alt=""
                    />
                  ) : (
                    <img
                      src={withoput_bussiness_license}
                      style={{ paddingLeft: '20px' }}
                    />
                  )}
                </div>
                <div className={Style.mainconpany}>
                  <div className={Style.mainconpanyinfo}>
                    <span className={Style.mainconpanytitle}>
                      {conpanyInfo.enterpriseName}
                    </span>
                    <div className={Style.mainconpanyspan}>
                      <span className={Style.mainconpanylabel}>
                        统一社会信用代码
                      </span>
                      <span className={Style.mainconpanyvalue}>
                        {conpanyInfo.uscc}
                      </span>
                    </div>
                    <div className={Style.mainconpanyspan}>
                      <span className={Style.mainconpanylabel}>法人代表</span>
                      <span className={Style.mainconpanyvalue}>
                        {conpanyInfo.corporate}
                      </span>
                    </div>
                    <div className={Style.mainconpanyspan}>
                      <span className={Style.mainconpanylabel}>合作形式</span>
                      <span className={Style.mainconpanyvalue}>
                        {conpanyInfo.cooperateType}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 消息通知 */}
            <div className={Style.messageBoxWrapper}>
              <MessageBox />
            </div>
          </div>
        </div>

        <Custompreviewimg
          onClose={() =>
            setPreviewimg({
              data: [],
            })
          }
          images={previewimg}
        />
      </Content>
    </Layout>
  )
}

export default Homepage
import { CSSProperties, useState, useMemo } from 'react'
import Style from './home.module.scss'
import { Layout, Button } from 'antd'
import { FileTextOutlined } from '@ant-design/icons'
import Custompreviewimg from '../../components/PreviewUser'
import companyicon from '../../assets/img/icon_conpany.png'
import xhOrderIcon from '../../assets/img/xhOrderIcon.png'
import myMaterialIcon from '../../assets/img/myMaterialIcon.png'
import myQuotationIcon from '../../assets/img/myQuotationIcon.png'
import wait_acceptance from '../../assets/img/wait_acceptance.png'
import clientOrderIcon from '../../assets/img/clientOrderIcon.png'
import wait_invoice_statement from '../../assets/img/wait_invoice_statement.png'
import useHooks from './hooks'
import { GetLocalStorage } from '../../tools/util'
import { Link } from 'react-router-dom'
import MessageBox from '../../modules/home/messagebox'
import TodoList from '../../modules/home/todolist'
import DashboardCard from '../../modules/home/dashboardcard'
import {
  DashboardCardSkeleton,
  CompanyInfoSkeleton,
  MessageBoxSkeleton,
} from '../../modules/home/skeletons'
import withoput_bussiness_license from '../../assets/img/withoput_bussiness_license.png'
import { StatusSearchDataEnum } from '../XhQuotation'
// 主页
const Homepage = () => {
  const {
    conpanyInfo,
    matterInfo,
    onRefresh,
    onJump,
    spinning,
    paymentCount,
    newestInvoice,
    jumpToNoticeDetail,
    permissionList,
    supplierCount,
    inquiryCount,
    workbenchPermissionList,
    workbenchMatter,
    workbenchCustomerOrder,
    workbenchInquiry,
    workbenchXhOrder,
    workbenchMatterLoading,
    workbenchCustomerOrderLoading,
    workbenchInquiryLoading,
    workbenchXhOrderLoading,
  } = useHooks()
  const { Content } = Layout
  const [previewimg, setPreviewimg] = useState<{
    data: string[]
    currentIndex?: number
  }>({ data: [] })
  const onClickPreview = () => {
    setPreviewimg({
      data: [conpanyInfo.licenseUrl],
      currentIndex: 0,
    })
  }
  const setType = (type: string) => {
    switch (type) {
      case '1':
        return '存续'
      case '2':
        return '在业'
      case '3':
        return '吊销'
      case '4':
        return '注销'
      case '5':
        return '迁入'
      case '6':
        return '迁出'
      case '7':
        return '停业'
      case '8':
        return '清算'
      default:
        break
    }
  }

  // 构建看板卡片数据
  const dashboardCards = useMemo(() => {
    const cards = []

    // 根据看板权限列表显示对应的卡片
    // 1. 电供客户订单
    if (workbenchPermissionList.includes('电供客户订单')) {
      cards.push({
        title: '电供客户订单',
        mainNumber: workbenchCustomerOrder?.totalCount || 0,
        icon: clientOrderIcon,
        loading: workbenchCustomerOrderLoading,
        link: '/srm/orderassurance?tab=total',
        items: [
          {
            label: '销项待开',
            value: workbenchCustomerOrder?.beInvoicedCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=all&orderState=已完成&accountOpenInvoiceStatus=未开票&positiveActualAmountOnly=true',
          },
          {
            label: '待结算',
            value: workbenchCustomerOrder?.beCollectedCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=all&paymentStatus=待申请',
          },
          {
            label: '待发货',
            value: workbenchCustomerOrder?.beShippedCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=waitship',
          },
          {
            label: '待验收',
            value: workbenchCustomerOrder?.beAcceptedCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=waitacceptance',
          },
          {
            label: '发货超期',
            value: workbenchCustomerOrder?.shipmentOverdueCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=overdue&overdueType=1',
            color: '#FF0000',
          },
          {
            label: '妥投超期',
            value: workbenchCustomerOrder?.properOverdueCount || 0,
            link: '/srm/orderassurance?page=CUSTOMER&tab=overdue&overdueType=2',
            color: '#FF0000',
          },
        ],
      })
    }

    // 2. 咸亨订单
    if (workbenchPermissionList.includes('咸亨订单')) {
      cards.push({
        title: '咸亨订单',
        mainNumber: workbenchXhOrder?.totalCount || 0,
        icon: xhOrderIcon,
        loading: workbenchXhOrderLoading,
        link: '/srm/orderassurance?page=SUPPLIER&tab=all',
        items: [
          {
            label: '待接单',
            value: workbenchXhOrder?.bePendingCount || 0,
            // 待接单：跳转到待发货tab，并且筛选待确认标签
            link: '/srm/orderassurance?page=SUPPLIER&tab=waitship&confirmState=true',
          },
          {
            label: '待发货',
            value: workbenchXhOrder?.beShippedCount || 0,
            link: '/srm/orderassurance?page=SUPPLIER&tab=waitship',
          },
        ],
      })
    }

    // 3. 我的询价单
    if (workbenchPermissionList.includes('我的询价单')) {
      cards.push({
        title: '我的询价单',
        mainNumber: workbenchInquiry?.totalCount || 0,
        icon: myQuotationIcon,
        loading: workbenchInquiryLoading,
        link: `/srm/xhQuotation?tab=${StatusSearchDataEnum.ALL}`,
        items: [
          {
            label: '待接单',
            value: workbenchInquiry?.bePendingCount || 0,
            link: `/srm/xhQuotation?tab=${StatusSearchDataEnum.PENDING}&status=WAITING_ORDER`, // 未完结tab，状态=待接单
          },
          {
            label: '待报价',
            value: workbenchInquiry?.beQuotedCount || 0,
            link: `/srm/xhQuotation?tab=${StatusSearchDataEnum.PENDING}&status=WAITING_QUOTE,WAITING_REQUOTE`, // 未完结tab，状态=待报价or待重新报价
          },
        ],
      })
    }

    // 4. 我的物料
    if (workbenchPermissionList.includes('我的物料')) {
      cards.push({
        title: '我的物料',
        mainNumber: workbenchMatter?.totalCount || 0,
        icon: myMaterialIcon,
        loading: workbenchMatterLoading,
        link: '/srm/goods',
        items: [
          {
            label: '审核中',
            value: workbenchMatter?.examineProductCount || 0,
            link: '/srm/mylaunch?type=LAUNCHGOODS',
          },
          {
            label: '驳回品牌',
            value: workbenchMatter?.rejectedBrandCount || 0,
            link: '/srm/mylaunch?type=LAUNCHBRAND&status=reject',
          },
          {
            label: '驳回物料',
            value: workbenchMatter?.rejectedProductCount || 0,
            link: '/srm/mylaunch?type=LAUNCHGOODS&status=reject',
          },
        ],
      })
    }

    return cards
  }, [
    workbenchPermissionList,
    workbenchMatter,
    workbenchCustomerOrder,
    workbenchInquiry,
    workbenchXhOrder,
    workbenchMatterLoading,
    workbenchCustomerOrderLoading,
    workbenchInquiryLoading,
    workbenchXhOrderLoading,
  ])

  return (
    <Layout style={{ height: '100%' }}>
      <Content className={Style.content}>
        {/* 数据看板区域 */}
        <div className={Style.dashboardSection}>
          {newestInvoice && (
            <div className={Style['xh-notice']}>
              <div className={Style['newest-notice']}>
                <span
                  style={{
                    color: '#435AFF',
                    marginRight: '8px',
                  }}
                >
                  <FileTextOutlined className={Style.mr8} />
                  公告
                  <span className={Style.ml8}>|</span>
                </span>
                <span
                  style={{ cursor: 'pointer' }}
                  onClick={jumpToNoticeDetail}
                >
                  {newestInvoice?.title || ''}
                </span>
              </div>
              <div
                className="primaryBtn"
                style={{ cursor: 'pointer', fontSize: '14px' }}
              >
                <Link to="/srm/xhNotice">
                  <span>{'全部 >>'}</span>
                </Link>
              </div>
            </div>
          )}
          <div className={Style.dashboardGrid}>
            {dashboardCards.map((card, index) => {
              const { loading, ...cardProps } = card
              return loading ? (
                <DashboardCardSkeleton key={index} />
              ) : (
                <DashboardCard key={index} {...cardProps} />
              )
            })}
          </div>
        </div>

        {/* 底部左右布局 */}
        <div className={Style.bottomSection}>
          {/* 左侧：待办事项清单 */}
          <div className={Style.leftSection}>
            <TodoList />
          </div>

          {/* 右侧：企业信息和消息通知 */}
          <div className={Style.rightSection}>
            {/* 企业信息 */}
            {spinning ? (
              <CompanyInfoSkeleton />
            ) : (
              <div className={Style.mainbox}>
                <div className={Style.maintitle}>
                  <span className={Style.maintitletext}>企业信息</span>
                  <div className={Style.mainheadbtn}>
                    <span
                      className="primaryBtn"
                      style={{
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '400',
                      }}
                      onClick={() => onJump('xhemployee')}
                    >
                      更多
                    </span>
                  </div>
                </div>
                <div className={Style.mainconpanypic}>
                  {conpanyInfo.licenseUrl ? (
                    <img
                      style={{
                        width: '240px',
                        height: '160px',
                        marginLeft: '20px',
                      }}
                      onClick={onClickPreview}
                      src={conpanyInfo.licenseUrl}
                      alt=""
                    />
                  ) : (
                    <img
                      src={withoput_bussiness_license}
                      style={{ paddingLeft: '20px' }}
                    />
                  )}
                </div>
                <div className={Style.mainconpany}>
                  <div className={Style.mainconpanyinfo}>
                    <span className={Style.mainconpanytitle}>
                      {conpanyInfo.enterpriseName}
                    </span>
                    <div className={Style.mainconpanyspan}>
                      <span className={Style.mainconpanylabel}>
                        统一社会信用代码
                      </span>
                      <span className={Style.mainconpanyvalue}>
                        {conpanyInfo.uscc}
                      </span>
                    </div>
                    <div className={Style.mainconpanyspan}>
                      <span className={Style.mainconpanylabel}>法人代表</span>
                      <span className={Style.mainconpanyvalue}>
                        {conpanyInfo.corporate}
                      </span>
                    </div>
                    <div className={Style.mainconpanyspan}>
                      <span className={Style.mainconpanylabel}>合作形式</span>
                      <span className={Style.mainconpanyvalue}>
                        {conpanyInfo.cooperateType}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* 消息通知 */}
            <div className={Style.messageBoxWrapper}>
              <MessageBox />
            </div>
          </div>
        </div>

        <Custompreviewimg
          onClose={() =>
            setPreviewimg({
              data: [],
            })
          }
          images={previewimg}
        />
      </Content>
    </Layout>
  )
}

export default Homepage
